// Imports => React
import { useMemo } from "react";
import { withStore } from "@stores";
import { observer } from "mobx-react-lite";
import clsx from "clsx";

// Imports => Constants

// Imports => Utilities
import { AcIsSet, AcIsArray } from "@opp/ui-kit";

// Imports => Atoms
import {
  AcContainer,
  AcRow,
  AcColumn,
  AcEmptyBlock,
  AcLoaderInline,
} from "@opp/ui-kit";

import AcSpecificationRowList from "../../../components/ac-specification-row-list/ac-specification-row-list";
import { withTranslation } from "react-i18next";
import { useGetSettlementsByUidSpecificationsAndSpecificationUidRowsQuery } from "@src/api/openapi/merchantApi";

const _CLASSES = {
  MAIN: "ac-settlement-specification-tab",
};

const AcSettlementSpecificationTab = ({
  specificationUid,
  settlementUid,
  t,
}) => {
  const { data, isFetching, refetch } =
    useGetSettlementsByUidSpecificationsAndSpecificationUidRowsQuery({
      specificationUid,
      uid: settlementUid,
      dateStart: "01-01-2000",
      perpage: 999,
      expand: ["payout"],
    });
  const currentSpecificationRows = data?.data;

  const handleListCallback = (event, { settlement_uid, specification_uid }) => {
    if (event && event.persist) event.persist();
    if (event && event.preventDefault) event.preventDefault();
    if (event && event.stopPropagation) event.stopPropagation();
    if (!AcIsSet(settlement_uid)) return;
    if (!AcIsSet(specification_uid)) return;

    const params = {
      order: "-period",
      date_start: "01-01-2000",
      perpage: 999,
      expand: ["payout"],
    };
  };

  const getMainClassNames = useMemo(() => {
    return clsx(_CLASSES.MAIN);
  });

  const renderSpecificationRows = useMemo(() => {
    if (isFetching) return <AcLoaderInline loading />;

    if (
      !AcIsSet(currentSpecificationRows) ||
      !AcIsArray(currentSpecificationRows) ||
      currentSpecificationRows.length === 0
    ) {
      return (
        <AcEmptyBlock
          message={t("no-rows-found", "No rows found to display", {
            ns: "payouts",
          })}
        />
      );
    }

    return (
      <AcSpecificationRowList
        items={currentSpecificationRows}
        callback={handleListCallback}
      />
    );
  }, [currentSpecificationRows, isFetching]);

  return (
    <div className={getMainClassNames}>
      <AcContainer fluid>
        <AcRow>
          <AcColumn xs={12}>{renderSpecificationRows}</AcColumn>
        </AcRow>
      </AcContainer>
    </div>
  );
};

export default withTranslation(["payouts", "store"])(
  withStore(observer(AcSettlementSpecificationTab))
);
